import UIConstants from '../../../constants/UIConstants';
import storeManager from '../../../store/StoreManager';
import DefaultThemeService from '../default/DefaultThemeServices';
import ceqRubricsLoader from './ceqRubricsLoader';
import uiService from '../../../services/UIService';
import questionReader from '../../../store/readHelpers/QuestionReader';
import marketplacePropertiesService from '../../../services/MarketplacePropertiesService';
import marketPlaces from '../../../constants/MarketPlaces';

export default class CeqService extends DefaultThemeService {
    scaleImage(imageId) {
        const zoomFactor = this.getZoomFactor();
        uiService.scaleImage(imageId, zoomFactor);
    }

    getZoomFactor() {
        const { ui: { zoomFactor } } = storeManager.getState();
        switch (zoomFactor) {
        case UIConstants.ZOOM_FACTOR.MEDIUM:
            return 19 / 16; // zoom-medium font size / regular font size
        case UIConstants.ZOOM_FACTOR.LARGE:
            return 22 / 16; // zoom-large font size / regular font size
        default:
            return 1;
        }
    }

    getQuestionRubricsContent(question) {
        return ceqRubricsLoader.getRubricsContent(question);
    }

    shouldAddExtraLineSpacing(question) {
        return questionReader.isInlineChoice(question);
    }

    // Paper based rubrics should be rendered for CEQ theme.
    shouldRenderPaperBasedRubric() {
        const pbRenderTheme = marketplacePropertiesService.getPbRenderStyle();
        return pbRenderTheme?.toUpperCase() === marketPlaces.ceq.toUpperCase();
    }
}
